module.exports = __webpack_public_path__ + "static/media/closeTab_gray.9181f916.jpg";